import BlogPostsWrapper, {
  AlwaysOnInfoAlert,
  DangerAlert,
  DangerMark,
  FlexAlignCenter,
  InfoAlert,
  InfoMark,
  SecTitle,
} from "./style"
import React from "react"
import { Container } from "react-bootstrap"
import PaperCanvas from "./PaperCanvas"
import { Link } from "gatsby"

class LegoArtMaker extends React.Component {
  render() {
    return (
      <BlogPostsWrapper>
        <SecTitle id="LEGO">MOSAIC ART MAKER</SecTitle>
        {/* Flex stretching works only on > sm screens. */}
        <FlexAlignCenter>
          <InfoAlert>
            <InfoMark>INFO :</InfoMark> For the best experience open this page
            on your macOS or PC.
          </InfoAlert>
        </FlexAlignCenter>
        <PaperCanvas></PaperCanvas>
        <Container>
          <FlexAlignCenter>
            <AlwaysOnInfoAlert>
              <InfoMark>HOW TO :</InfoMark>{" "}
              <Link
                to={
                  "https://www.hvitis.dev/mosaic-art-creator-mosaic-and-portraits-free-online-editor"
                }
              >
                {" "}
                Click here{" "}
              </Link>{" "}
              to learn how to use this generator. You can use <b>
                .bsx
              </b> and <b>.xml</b> files on{" "}
              <Link to={"https://www.bricklink.com/v2/wanted/upload.page"}>
                BrickLink.com{" "}
              </Link>{" "}
              to buy generated studs or on{" "}
              <Link to={"https://www.bricklink.com/v3/studio/download.page"}>
                stud.io{" "}
              </Link>{" "}
              to render the picture in 3D.
            </AlwaysOnInfoAlert>
          </FlexAlignCenter>
          <FlexAlignCenter>
            <DangerAlert>
              {" "}
              <DangerMark>DISCLAIMER :</DangerMark> LEGO and the LEGO logo are
              trademarks and/or copyrights of the LEGO Group. This project is
              not at all affiliated with The LEGO Group, and was simply a
              project of mine using the LEGO name as a proprietary eponym.{" "}
            </DangerAlert>
          </FlexAlignCenter>
          
        </Container>
      </BlogPostsWrapper>
    )
  }
}

export default LegoArtMaker
